import React from 'react';
import { useSelector } from 'react-redux';
import { DeviceTypes } from '../types/client-data';

const OnlyRenderOn = ({
    children,
    app,
    web,
    pc,
    h5,
}: React.PropsWithChildren<OnlyRenderOnProps>) => {
    const trueProps = [app && 'app', web && 'web', pc && 'pc', h5 && 'h5'].filter(
        Boolean
    ) as string[];
    const trueCount = trueProps.length;

    if (trueCount > 1) {
        throw new Error(
            `You cannot use this component with multiple properties specified as true. Found: ${trueProps.join(
                ', '
            )}. Only one of app, web, pc, or h5 can be true at a time.`
        );
    }

    if (trueCount === 0) {
        throw new Error(
            'You must specify one of the app, web, pc, or h5 properties when using this component.'
        );
    }

    const isAppView = useSelector(selectState);
    const isPCView = useSelector(selectPCState);

    if (pc && isPCView) {
        return <>{children}</>;
    }

    if (h5 && !isPCView) {
        return <>{children}</>;
    }

    if (app && isAppView) {
        return <>{children}</>;
    }

    if (web && !isAppView) {
        return <>{children}</>;
    }

    return null;
};

function selectState(state: AppViewState) {
    return !!state?.page?.appViewDevice;
}

function selectPCState(state: AppViewState) {
    return state?.baseConfig?.device?.type !== DeviceTypes.MOBILE;
}

interface OnlyRenderOnProps {
    app?: boolean;
    web?: boolean; // contains pc and broser on app
    pc?: boolean;
    h5?: boolean;
}

type AppViewState = {
    page: {
        appViewDevice: string | null;
    };
    baseConfig: {
        device: {
            type: DeviceTypes;
        };
    };
};

export default OnlyRenderOn;
